import { group, groupWithIdentify } from './AnalyticsService.js'

export function groupWithBankAccountSetup() {
  return group({ bank_account_setup: true })
}

export function groupWithIndustries(industries) {
  return groupWithIdentify({ industries: industries })
}

export function groupWithBusinessPhone(businessPhone) {
  return groupWithIdentify({ business_phone: businessPhone})
}

export function groupWithBusinessName(companyName) {
  return groupWithIdentify({ company_name: companyName})
}

export function groupWithInstapayEnabled(selectedDepositMethod) {
  return groupWithIdentify({ instapay_enabled: (selectedDepositMethod == 'instant'? true : false) })
}

export function groupWithEmployeeCount(employeesCount) {
   return groupWithIdentify({ declared_employee_count: employeesCount})
}

export function groupWithAvailableDomainUrl(url) {
  return groupWithIdentify({ available_domain_url: url })
}

export function groupWithWebsiteBuilderDomain(url) {
  return groupWithIdentify({ website_builder_domain: url })
}

export function groupWithPhoneNumberValid(isPhoneValid) {
  return group({ is_phone_valid: isPhoneValid })
}
